// extracted by mini-css-extract-plugin
export default {"floatingBanner":"_C09oX","chat":"pemDEu","fullPage":"vVx8U6","home":"qkAFV8","hasFooter":"GAQcpN"};